import {useNavigationService} from '@/di/di.root-container.hooks';

import {useEffect, useRef, useState} from 'react';
import {Navigate} from 'react-router';
import {useParams} from 'react-router-dom';

import cn from 'classnames';

import {clientRoutes} from '@/constants';
import {useElementInViewport} from '@/hooks/useElementInViewport';
import {useGameStatusStore} from '@/stores/connectors';
import {InviteIntro} from '@/ui/components/Intro/InviteIntro';
import {InviteCta} from '@/ui/components/InviteCta/InviteCta';
import {MainFeatures} from '@/ui/components/MainFeatures/MainFeatures';
import {MainGifts} from '@/ui/components/MainGifts/MainGifts';
import {Footer} from '@/ui/kit/Footer/Footer';
import {PreloaderCustom} from '@/ui/kit/PreloaderCustom/PreloaderCustom';

import s from './InvitePage.module.css';

export default function InvitePage(): JSX.Element {
  const navigationService = useNavigationService();
  const gameStatusStore = useGameStatusStore();

  const isStatusGameFinished = gameStatusStore.isStatusGameFinished();
  const isStatusGameMocks = gameStatusStore.isStatusGameMocks();
  const isStatusActive = gameStatusStore.isStatusActive();
  const isSuccessFetchStatus = gameStatusStore.isSuccessFetchStatus();

  const params = useParams();
  const {refId} = params;

  const introRef = useRef<HTMLDivElement>(null);
  const [showFixedButton, setShowFixedButton] = useState(false);

  const isVisibleIntroSection = useElementInViewport({
    containerRef: introRef,
    options: {threshold: 0},
  });

  useEffect(() => {
    if (isStatusGameMocks) {
      navigationService.navigateToClickerGamePage();
    }
    if (isStatusGameFinished) {
      navigationService.navigateToMainPage();
    }
  }, [navigationService, isStatusGameFinished, isStatusGameMocks]);

  useEffect(() => {
    setShowFixedButton(Boolean(!isVisibleIntroSection && introRef.current));
  }, [isVisibleIntroSection, introRef]);

  if (!refId) {
    return <Navigate to={clientRoutes.Main} replace />;
  }

  if (isSuccessFetchStatus && isStatusActive) {
    return (
      <main className={s.root}>
        <div ref={introRef} className={s.intro}>
          <InviteIntro />
        </div>
        <MainFeatures className={s.features} />
        <MainGifts className={s.gifts} />
        <Footer />
        <div
          className={cn(s.fixedButton, {
            [s.fixedButtonShow]: showFixedButton,
          })}
        >
          <InviteCta />
        </div>
      </main>
    );
  }

  return (
    <main className={cn(s.root, s.loaderWrapper)}>
      <PreloaderCustom />
    </main>
  );
}
